// utils/toast.js
import toastr from "toastr";
import "toastr/build/toastr.min.css";

toastr.options = {
  positionClass: "toast-top-right",
  timeOut: 3000,
  progressBar: true,
  closeButton: true,
};

export default toastr;
